// frontend/src/components/games/sudoku/sudokuConstants.ts

export type SudokuDifficulty = 'easy' | 'medium' | 'hard';

export interface SudokuDifficultyConfig {
  label: string;
  /** Bulmacada bırakılacak (önceden dolu) hücre sayısı hedefi. */
  clues: number;
}

export const SUDOKU_DIFFICULTIES: Record<SudokuDifficulty, SudokuDifficultyConfig> = {
  easy: { label: 'Kolay', clues: 40 },
  medium: { label: 'Orta', clues: 32 },
  hard: { label: 'Zor', clues: 26 },
};
